<template>
  <div class="due-date-tooltip-wrap">
    <div class="due-date-label">
      {{ dueDateLabel(props.dueDate * 1000) }}
    </div>
    <div class="due-date">
      {{ getDateFromTimestamp() }}
    </div>
  </div>
</template>

<script setup lang="ts">
import { computed } from 'vue';
import useTranslate from '@/utilities/composables/useTranslate';
import { getHumanReadableDate } from '@/utilities/getHumanReadableDate';
const { translate } = useTranslate();

const props = defineProps<{
  dueDate: number;
}>();

const monthsLabel = computed((): string => translate('months').split(','));

const dueDateLabel = (date: Date): string => {
  return getHumanReadableDate(date);
};

const getDateFromTimestamp = () => {
  const dueDate = new Date(props.dueDate * 1000);
  return `${translate('dueOn')}
          ${monthsLabel.value[dueDate.getMonth()]}
          ${dueDate.getDate()}`;
};
</script>

<style lang="scss">
.due-date-tooltip-wrap {
  .due-date {
    font-weight: 500;
    font-size: 12px;
    line-height: 18px;
    @apply text-attention-text;
  }

  .due-date-label {
    font-size: 11px;
    line-height: 18px;
    letter-spacing: 0.02em;
    @apply text-attention-text;
  }
}
</style>
